import { Command } from 'ckeditor5';
import { PlaceholderStore } from './store';
import { findPlaceholders } from './utils';
/**
 * Repoints **every** occurrence of question `from` at question `to`, in a single undoable step — one
 * occurrence at a time would leave the rest pointing at a ref that no longer resolves. Returns the
 * number rewritten.
 */
export class RenamePlaceholderRefCommand extends Command {
    execute(options) {
        const { from, to } = options;
        const { editor } = this;
        if (from === to) {
            return 0;
        }
        const elements = findPlaceholders(editor.model, (element) => element.getAttribute('id') === from);
        if (!elements.length) {
            return 0;
        }
        const store = editor.plugins.get(PlaceholderStore);
        elements.forEach((element) => {
            const instanceId = element.getAttribute('instanceId');
            if (instanceId) {
                store.updatePlaceholderId(instanceId, to);
            }
        });
        editor.model.change((writer) => {
            elements.forEach((element) => {
                writer.setAttribute('id', to, element);
                editor.editing.reconvertItem(element);
            });
        });
        return elements.length;
    }
}
